import React, { useState } from "react";
import { Button, Table } from "react-bootstrap";

const CostEstimatesTable = () => {
     const [searchTerm, setSearchTerm] = useState('');
      const [currentPage, setCurrentPage] = useState(1);
      const itemsPerPage = 5;

  const costEstimates = [
    { service: "General Consultation", estimatedCost: 5000, hmoCoverage: 4000, outOfPocket: 1000 },
    { service: "Surgery", estimatedCost: 150000, hmoCoverage: 120000, outOfPocket: 30000 },
    { service: "Lab Tests", estimatedCost: 15000, hmoCoverage: 12000, outOfPocket: 3000 },
    { service: "Medications", estimatedCost: 10000, hmoCoverage: 7000, outOfPocket: 3000 },
    { service: "Emergency Services", estimatedCost: 50000, hmoCoverage: 45000, outOfPocket: 5000 },
  ];


  const filteredData = costEstimates.filter(
    (item) =>
      // item.estimatedCost.toLowerCase().includes(searchTerm.toLowerCase()) ||
      // item.hmoCoverage.toLowerCase().includes(searchTerm.toLowerCase()) ||
      // item.outOfPocket.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.service.includes(searchTerm)
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  return (<>
    <Table striped  hover responsive>
      <thead>
        <tr>
          <th></th>
          <th>Service</th>
          <th>Estimated Cost (₦)</th>
          <th>HMO Coverage (₦)</th>
          <th>Out-of-Pocket (₦)</th>
        </tr>
      </thead>
      <tbody>
        {filteredData.map((item, index) => (
          <tr key={index}>
            <td>
            <div className="d-flex align-items-center gap-2">
                       <div className="avatar border border-2 border-success text-info d-flex justify-content-center align-items-center">
                        <i className="ri-information-line"></i>
                  </div>
                  </div>
            </td>
            <td>{item.service}</td>
            <td>{item.estimatedCost.toLocaleString()}</td>
            <td>{item.hmoCoverage.toLocaleString()}</td>
            <td>{item.outOfPocket.toLocaleString()}</td>
          </tr>
        ))}
      </tbody>
    </Table>
    <div className="d-flex justify-content-between align-items-center mt-3">
                  <Button
                  variant="light"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                  >
                  Previous
                  </Button>
                  <span>Page {currentPage} of {totalPages}</span>
                  <Button
                  variant="light"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(currentPage + 1)}
                  >
                  Next
                  </Button>
                  </div>
  </>
  );
};

export default CostEstimatesTable;
